/* Sui Story — Lenis smooth scroll.
   Must be initialised BEFORE GSAP ScrollTrigger is used (see CLAUDE.md).
   Defines the shared SuiStory namespace + reduced-motion helper. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});

  S.reduceMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  S.initLenis = function () {
    if (S.lenis) return S.lenis;
    if (typeof Lenis === 'undefined' || S.reduceMotion()) return null;

    var lenis = new Lenis({
      duration: 1.1,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      smoothTouch: false, // keep native momentum on touch devices
      touchMultiplier: 1.5
    });
    S.lenis = lenis;

    // Drive Lenis from GSAP's ticker and keep ScrollTrigger in sync.
    if (window.gsap && window.ScrollTrigger) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      var raf = function (time) { lenis.raf(time); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
    return lenis;
  };

  S.stopLenis = function () { if (S.lenis) S.lenis.stop(); };
  S.startLenis = function () { if (S.lenis) S.lenis.start(); };
  S.scrollToTop = function () {
    if (S.lenis) S.lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  };
})();
